import { Tag } from '@cian/components';
import * as React from 'react';

import { IDecorationTag } from '../../../state/tags/definitions/decoration';
import { TagNew } from '../TagNew';

import { tagThemeSmall } from '../tag_theme';

export interface IDecorationTagItemProps {
  tag: IDecorationTag;
  withNewTag?: boolean;
  onDeleteClick(): void;
}

export const DecorationTagItem = ({ onDeleteClick, tag, withNewTag }: IDecorationTagItemProps) => {
  const TagComponent = React.useMemo(() => (withNewTag ? TagNew : Tag), [withNewTag]);

  return (
    <TagComponent onDeleteClick={onDeleteClick} tagStyles={tagThemeSmall}>
      {tag.value ? 'С отделкой' : 'Без отделки'}
    </TagComponent>
  );
};
